"use strict";

import PageCommon from "./PageCommon.js";
import Globals    from "../Globals.js";
import Tracks     from "./Tracks/Tracks.js";
import Track      from "./Tracks/Track.js";
import Artist     from "./Artists/Artist.js";


export default class VideoManager extends PageCommon {
    constructor() {
        super();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - constructor");

        this.indexedDB = null;

        this.youtubePlayer = null;
        this.videoContainer = null;

        this.readyToRun = false;
        this.playingInterval = null;
        this.retryCounter = 0;
        this.maxRetry = 10;

        this.supportedVideoType = ["video/mp4", "video/quicktime", "video/ogg", "video/webm"];
        this.maxVideoMB = 5000;
        this.autoload = false;

        this.aiMusicID = -1000;
    }
    run({ indexedDB }) {
        this.readyToRun = true;
        this.indexedDB = indexedDB;
        const _this = this;
        document.addEventListener("video_found", (event) => {
            document.querySelector(".sync-tool").style.display = "";
            const videoFromDB = event.detail;
            if (videoFromDB) {
                _this.setupSeek();
                _this.loadUploadedVideo(videoFromDB.file, videoFromDB.name);
            }
        });
        document.addEventListener("youtube_video_found", (event) => {
            document.querySelector(".sync-tool").style.display = "";
            this.autoload = true;
            // this.setupIframe(event.detail.url);
            this.setupYoutubeVideo(event.detail.url);
        });
    }
    init() {
        super.init();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - init");
        this.videoContainer = document.querySelector("#videoBlock");
        this.setupEvents();
    }

    setupEvents() {
        const _this = this;
        // this.videoContainer.querySelector(".url-container input").addEventListener("keyup", (event) => {
        //     if (event.target.value != "") {
        //         const keyCode = this.getKeyCode(event);
        //         if (keyCode === "Enter") {
        //             return this.setupIframe(event.target.value);
        //         }
        //         return (_this.videoContainer.querySelector(".sync-controls button").disabled = false);
        //     }
        //     _this.videoContainer.querySelector(".sync-controls button").disabled = true;
        // });
        this.videoContainer.querySelector(".url-container input").addEventListener("keyup", (event) => {
            if (event.target.value != "") {
                const keyCode = this.getKeyCode(event);
                if (keyCode === "Enter") {
                    return this.setupYoutubeVideo(event.target.value);
                }
                return (_this.videoContainer.querySelector(".sync-controls button").disabled = false);
            }
            _this.videoContainer.querySelector(".sync-controls button").disabled = true;
        });
        this.videoContainer.querySelector(".sync-controls button").addEventListener("click", (event) => {
            // const youtubeUrl = _this.videoContainer.querySelector(".url-container input").value;
            // if (youtubeUrl) {
            //     this.setupYoutubeSeek();
            //     return this.setupIframe(youtubeUrl);
            // }
            const youtubeUrl = _this.videoContainer.querySelector(".url-container input").value;
            if (youtubeUrl) {
                return this.setupYoutubeVideo(youtubeUrl);
            }
            this.setupSeek();
            const uploadedVideo = _this.videoContainer.querySelector(".drop-container input").files[0];
            return this.setupUploadedVideo(uploadedVideo);
        });
        this.videoContainer.addEventListener("drop", (event) => {
            event.preventDefault();
            const input = event.currentTarget.querySelector("input");
            input.files = event.dataTransfer.files;
            _this.videoContainer.querySelector(".sync-controls button").disabled = false;
            _this.emitEvent("click", null, _this.videoContainer.querySelector(".sync-controls button"));
        });
        this.videoContainer.addEventListener("dragover", (event) => {
            event.preventDefault();
            event.currentTarget.classList.add("dropping");
        });
        this.videoContainer.addEventListener("dragleave", (event) => {
            event.preventDefault();
            event.currentTarget.classList.remove("dropping");
        });
        this.videoContainer.querySelector(".drop-container input").addEventListener("change", (event) => {
            event.preventDefault();
            _this.videoContainer.classList.add("dropping");
            _this.videoContainer.querySelector(".sync-controls button").disabled = false;
            _this.emitEvent("click", null, _this.videoContainer.querySelector(".sync-controls button"));
        });
        this.videoContainer.querySelector(".play-video").addEventListener("click", (event) => {
            const video = _this.videoContainer.querySelector("video");
            if (!video.paused) {
                this.emitEvent("video_pause");
                return this.setPause(video);
            }
            this.setPlay(video);
            this.emitEvent("video_play");
        });
        document.addEventListener("track_play", (event) => {
            if (_this.youtubePlayer) {
                _this.youtubePlayer.playVideo();
            } else {
                const video = _this.videoContainer.querySelector("video");
                this.setPlay(video);
            }
        });
        document.addEventListener("track_pause", (event) => {
            if (_this.youtubePlayer) {
                _this.youtubePlayer.pauseVideo();
            } else {
                const video = _this.videoContainer.querySelector("video");
                _this.setPause(video);
            }
        });

        this.videoContainer.querySelector("button.change-video").addEventListener("click", (event) => {
            _this.resetVideo();
            $(document.body).trigger("sticky_kit:recalc");
        });

        this.videoContainer.querySelector("button.ai-music").addEventListener("click", (event) => {         // PF - AI MUSIC GENERATOR 2504

            this.videoContainer.querySelector("button.ai-music").style.pointerEvents = 'none';

            // this.pShowPreload();
            // document.querySelector("#contentWrapper").querySelector("#tracksSection .tracks-list").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;
            if (document.querySelector("#tracksSection")) document.querySelector("#tracksSection").style.display = "none";
            Globals.searchManager.resetAllSections();

            if (document.querySelector("#aiTracksSection")) {
                document.querySelector("#aiTracksSection .tracks-list").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;
            } else {
                document.querySelector("#contentWrapper").insertAdjacentHTML("afterbegin", `  
                    <div id="aiTracksSection" class="fm-section">
                        <div class="fm-section-header">
                            <h4>Generated Music</h4>
                        </div>
                        <div class="tracks-list"><div class="js-preloader small"><div class="spinner"></div></div></div>
                    </div>
                    `);
            }

            const url_ai = 'https://sounzone.com/szwsaimusic/';
            const data = {
                mode: "GENERATE",
                imgData: this.pVideoToImgStr(),
                _u: "" + (new Date()),
            };
            const formData = new URLSearchParams(data).toString();

            fetch(url_ai, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData,
            })
                .then(response => response.json())
                .then(result => {

                    var taskId = result.suno.data.taskId;

                    /*  
                    console.log("--- AI MUSIC -------------------------------------------------- BEGIN ");
                    console.log("taskId: " + taskId);
                    console.log(result);
                    console.log("--- AI MUSIC -------------------------------------------------- END ");
                    //*/

                    this.pAIMusicStatus(taskId);
                    
                    console.log("Done!");
                    // Handle the response here
                    this.pAIMusicResult();
                })
                .catch(error => {
                    // Handle errors here
                    console.log("--- AI MUSIC --- ERROR ");
                    console.log(error);
                    this.pAIMusicResult("Error, generation aborted");
                });

        });

        this.videoContainer.querySelector("button.ai-video").addEventListener("click", (event) => {         // PF - VIDEO TOOL AI 2307

            this.videoContainer.querySelector("button.ai-video").style.pointerEvents = 'none';

            this.pShowPreload();

            const url_ai = 'https://sounzone.com/szwsai/';
            // const formData = new FormData(); formData.append('imgData', imgDataStr );
            const data = {
                imgData: this.pVideoToImgStr(),
                _u: ""+(new Date()),
            };
            const formData = new URLSearchParams(data).toString();

            fetch(url_ai, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData, // JSON.stringify(data),
            })
                .then(response => response.json())
                .then(result => {
                    document.querySelector(".ai-debug").innerHTML = result.ta2.join(", &nbsp; ");
                    /*  
                    console.log(result);
                    console.log("--- AI -------------------------------------------------- BEGIN ");
                    console.log("Elements found by AI: " + result.ta.join(", "));
                    console.log("Tag System Output: " + result.ka.join(", "));
                    console.log("--- AI -------------------------------------------------- END ");
                    //*/
                    if (result.ka.length > 0) {
                        try {
                            Globals.searchManager.resetSearchList("");
                        } catch (error) {
                            console.error("[JS] "+error);
                        }
                        result.ka.forEach((element, index, array) => {
                            Globals.searchManager.createKeywordSearched(element, "tag");
                            // console.log(`Element at index ${index}: ${element}`);
                        });
                        Globals.searchManager.searchTracks();
                    }
                    // console.log("Done!");
                    // Handle the response here
                    this.videoContainer.querySelector("button.ai-video").style.pointerEvents = 'inherit';
                })
                .catch(error => {
                    // Handle errors here
                    this.videoContainer.querySelector("button.ai-video").style.pointerEvents = 'inherit';
                });
            // const newTab = window.open(); newTab.document.write(image.outerHTML);
        });

        this.videoContainer.querySelector("button.hide-video").addEventListener("click", () => {
            /*_this.emitEvent("video_pause");
            clearInterval(_this.playingInterval);
            if (_this.youtubePlayer) {
                _this.youtubePlayer.pauseVideo();
            } else {
                const video = _this.videoContainer.querySelector("video");
                _this.setPause(video);
            }*/
            _this.videoContainer.querySelector(".video-container").classList.add("compressed");
            $(document.body).trigger("sticky_kit:recalc");
        });
        this.videoContainer.querySelector("button.show-video").addEventListener("click", () => {
            _this.videoContainer.querySelector(".video-container").classList.remove("compressed");
            $(document.body).trigger("sticky_kit:recalc");
        });
        this.videoContainer.querySelector("button.fullscreen-btn").addEventListener("click", () => {
            _this.showVideoFullscreen();
        });
    }

    pAIMusicResult(msg="") {
        if (msg!="") alert(msg);
        this.videoContainer.querySelector("button.ai-music").style.pointerEvents = 'inherit';
    }

    pAIMusicStatus(taskId) {

        $.ajax({
            url: 'https://sounzone.com/szwsaimusic/?mode=STATUS&taskId=' + taskId + "&_U=" + Math.random(),
            type: 'GET',
            dataType: 'json', 
            success: (data) => {

                console.log("--- AI MUSIC STATUS -------------------------------------------------- BEGIN ");
                console.log(data);

                var canAddTracks = false;

                if (data.data.response !== null) { 
                    canAddTracks = 0;
                    if (data.data.response.sunoData.length > 0) {
                        for (var k = 0; k < data.data.response.sunoData.length; k++) {
                            var u = data.data.response.sunoData[k];
                            if (u.duration > 0 && u.audioUrl != "") canAddTracks++;
                        }   
                    }
                    canAddTracks = (canAddTracks>0 && canAddTracks == data.data.response.sunoData.length);
                }
                /*
                if (data.data.status == "PENDING") {
                    console.log("[Ai-Music] Pending");
                }
                else
                */
                if (canAddTracks)
                {
                    // Globals.dataManager.dataStructure.tracks = data.data.response.sunoData[0];

                    // Artist AI = 49105

                    // ---

                    var aiArtist, track, tracks = Globals.dataManager.dataStructure.tracks;

                    const tracksList = document.querySelector("#aiTracksSection .tracks-list");

                    fetch(`${Globals.URL_FETCH_BLOCK}tracks-list.html`)
                        .then((data) => data.text())
                        .then((html) => {
                            tracksList.innerHTML = html;

                            const tracksListBody = tracksList.querySelector(".tracks-list-body");
                            tracksListBody.textContent = "";

                            /*
                            if (this.searchResults) {
                                this.searchResults.map((id) => {
                                    const track = this.tracks.get({ id });
                                    if (track) {
                                        tracksListBody.appendChild(this.tracks.getItem(track));
                                    }
                                });
                            }
                            //*/

                            for (var k = 0; k < data.data.response.sunoData.length; k++) {

                                var u = data.data.response.sunoData[k];

                                /*
                                {
                                    "id": "ac7b6d22-0eb7-4142-8bd7-c876a4386237",
                                    "audioUrl": "https://apiboxfiles.erweima.ai/YWM3YjZkMjItMGViNy00MTQyLThiZDctYzg3NmE0Mzg2MjM3.mp3",
                                    "sourceAudioUrl": "https://cdn1.suno.ai/ac7b6d22-0eb7-4142-8bd7-c876a4386237.mp3",
                                    "streamAudioUrl": "https://mfile.erweima.ai/YWM3YjZkMjItMGViNy00MTQyLThiZDctYzg3NmE0Mzg2MjM3",
                                    "sourceStreamAudioUrl": "https://cdn1.suno.ai/ac7b6d22-0eb7-4142-8bd7-c876a4386237.mp3",
                                    "imageUrl": "https://apiboxfiles.erweima.ai/YWM3YjZkMjItMGViNy00MTQyLThiZDctYzg3NmE0Mzg2MjM3.jpeg",
                                    "sourceImageUrl": "https://cdn2.suno.ai/image_ac7b6d22-0eb7-4142-8bd7-c876a4386237.jpeg",
                                    "prompt": "",
                                    "modelName": "chirp-v4",
                                    "title": "Guardians of the Mini Realm",
                                    "tags": "Epic Orchestral",
                                    "createTime": 1746499734070,
                                    "duration": 141
                                }
                                */

                                // ---

                                const newArtistProps = {
                                    ID: -2000,
                                    Name: "AI Artist",
                                    Image: { High: "0.jpg", Medium: "0.jpg" },
                                    Wallpaper: "0.jpg",
                                    Description: "",
                                    Format: 0,
                                    isNew: true
                                };

                                aiArtist = new Artist(newArtistProps, ["AI Artist"]);

                                Globals.dataManager.dataStructure.artists.data.push(aiArtist);

                                // ---

                                u.duration = Math.floor(u.duration);

                                var tid = (--this.aiMusicID);

                                var o = {
                                    "ID": tid,
                                    "Name": "(" + (k + 1) + ") " + u.title,
                                    "MP3": {
                                        "Length": u.duration,
                                        "LengthFMT": `${Math.floor(u.duration / 60)}:${String(u.duration % 60).padStart(2, '0')}`,
                                        "Url": u.audioUrl,
                                    },
                                    "Artists": [aiArtist], // AI Fake Artist -- 49105
                                    "isNew": true
                                };

                                track = new Track(o);
                                track.artistsConverted = true;

                                Globals.dataManager.dataStructure.tracks.data.push(track);

                                // document.querySelector("#contentWrapper").insertAdjacentHTML("afterbegin", ``);
                                // tracksListBody.appendChild(tracks.getItem(tracks.get({ tid })));
                                
                                tracksListBody.appendChild(track.renderListItem(Globals.userManager, [aiArtist], Globals.dataManager.dataStructure.playlists));

                                // tracksListBody.insertAdjacentHTML("afterbegin", ``);

                            }

                            this.emitEvent("search_result_rendered");
                        });

                    // ---

                    console.log(Globals.dataManager.dataStructure.tracks);

                    this.pAIMusicResult();
                }
                else
                {
                    setTimeout(() => {
                        this.pAIMusicStatus(taskId);
                    }, 2000);
                }

                console.log("--- AI MUSIC STATUS -------------------------------------------------- END "); 

            },
            error: function (xhr, status, error) {
                // Handle any errors that occurred during the request
                console.error("Error fetching JSON:", status, error);
            }
        });

    }

    pVideoToImgStr() {
        const videoElement = document.getElementById("uploadedVideo");
        var cw = videoElement.videoWidth;
        var ch = videoElement.videoHeight;
        const sv = cw / 1024;
        if (sv > 1) {
            cw /= sv;
            ch /= sv;
        }
        const canvas = Object.assign(document.createElement("canvas"), { width: cw, height: ch });
        canvas.getContext("2d").drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        // const image = new Image();
        // console.log(canvas.toDataURL("image/jpeg",0.75));
        const imgDataStr = canvas.toDataURL("image/jpeg", 0.75);
        return imgDataStr;
    }

    pShowPreload() {
        // this.showPreloader(true); // <-- Full page preloader
        // Tracks Preloader
        document.querySelector("#contentWrapper").querySelector("#tracksSection .tracks-list").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;
        Globals.searchManager.resetAllSections();
        // ---
    }

    resetVideo() {
        this.videoContainer.querySelector(".video-container").style.display = "none";
        this.videoContainer.querySelector(".drop-container").classList.remove("dropping");
        this.videoContainer.querySelector(".drop-container input").files = new DataTransfer().files;
        this.videoContainer.querySelector(".url-container input").value = "";
        this.videoContainer.querySelector(".sync-tool-content").classList.remove("hide");
        this.videoContainer.querySelector(".sync-controls button").disabled = true;
        this.videoContainer.querySelector("#localVideo").classList.remove("playing");
        this.videoContainer.querySelector("#localVideo").style.display = "none";
        this.videoContainer.querySelector("#youtubeVideo").style.display = "none";
        this.emitEvent("video_pause");
        clearInterval(this.playingInterval);
        if (this.youtubePlayer) {
            this.youtubePlayer.pauseVideo();
        } else {
            const video = this.videoContainer.querySelector("video");
            this.setPause(video);
            video.src = "";
        }
        this.youtubePlayer = null;
        this.videoContainer.querySelector("#youtubeVideo").remove();
        const youtubeVideo = document.createElement("div");
        youtubeVideo.id = "youtubeVideo";
        this.videoContainer.querySelector(".video-wrapper").appendChild(youtubeVideo);
        this.indexedDB.delete(1);
        window.localStorage.removeItem("youtube_video_url");
        document.querySelector(".sync-tool .wrapper-img").style.display = "";

        // document.querySelector(".fm-main-content").style.cssText += ";margin-top:460px"; /* 221229 - Sticky Header */
    }

    parseUrlYoutube(url) {
        return /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/.exec(url)[1];
    }

    addYoutubeAPI() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - Add Youtube API");
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    setupIframe(url) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - Setup iframe");
        this.videoContainer.querySelector(".sync-tool-content").classList.add("hide");
        this.videoContainer.querySelector(".video-container").style.display = "";
        this.videoContainer.querySelector("#youtubeVideo").style.display = "block";
        const _this = this;
        this.youtubePlayer = new YT.Player("youtubeVideo", {
            videoId: _this.parseUrlYoutube(url),
            events: {
                onReady: (event) => _this.onPlayerReady(event),
                onStateChange: (event) => _this.onPlayerStateChange(event),
            },
            playerVars: {
                autoplay: 0,
                controls: 0,
                disablekb: 1,
                fs: 0,
                loop: 0,
                modestbranding: 1,
                showtitle: 0,
                rel: 0,
                showinfo: 0,
                mute: 1,
                autohide: 1,
                share: 0,
            },
        });
    }

    onYouTubeIframeAPIReady() {
        if (this.readyToRun) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - Youtube API Ready");
            this.init();
        } else if (this.retryCounter < this.maxRetry) {
            this.retryCounter++;
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - Retry " + this.retryCounter);
            setTimeout(() => {
                this.onYouTubeIframeAPIReady();
            }, 1000);
        } else {
            this.retryCounter = 0;
        }
    }

    onPlayerReady(event) {
        const _this = this;
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("VideoManager - Youtube Video Ready");
        if (!_this.autoload) {
            event.target.playVideo();
        }
        _this.autoload = false;
    }

    onPlayerStateChange(event) {
        const _this = this;
        if (event.data == YT.PlayerState.PLAYING) {
            this.emitEvent("video_play");
            _this.startYoutubeIntervalManager(_this, event.target);
        } else if (event.data == YT.PlayerState.PAUSED) {
            this.emitEvent("video_pause");
            clearInterval(_this.playingInterval);
        }
    }

    startYoutubeIntervalManager(_this, video) {
        _this.updateYoutubeCurrentTime(_this, video);
        _this.playingInterval = setInterval(() => {
            _this.updateYoutubeCurrentTime(_this, video);
        }, 1000);
    }

    updateYoutubeCurrentTime(_this, video) {
        _this.videoContainer.querySelector(".current-timeline").textContent = _this.formatTime(video.getCurrentTime());
        const timeline = _this.videoContainer.querySelector(".timeline");
        const x = (timeline.getBoundingClientRect().width * video.getCurrentTime()) / parseInt(video.getDuration());
        timeline.querySelector(".bar2").style.width = `${x}px`;
        _this.videoContainer.querySelector(".seek-timeline").textContent = _this.formatTime(video.getDuration());
    }

    setupYoutubeSeek() {
        const container = this.videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");
        timeline.addEventListener("mousemove", (event) => {
            const { x, y } = this.getMouseCoordinate(event, timeline);
            this.setYoutubeSeekPosition(x);
        });
        timeline.addEventListener("mouseleave", (event) => {
            this.setYoutubeSeekPosition(0);
        });
        timeline.addEventListener("click", (event) => {
            const { x, y } = this.getMouseCoordinate(event, timeline);
            this.setYoutubeSeekTime(this.videoContainer, x);
        });
    }

    setYoutubeSeekPosition(x) {
        const container = this.videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");

        const video = this.youtubePlayer;
        const positionTime = (parseInt(video.getDuration()) * x) / timeline.getBoundingClientRect().width;

        const seekTime = this.formatTime(positionTime);
        container.querySelector(".seek-timeline").textContent = seekTime;

        timeline.querySelector(".bar3").style.width = `${x}px`;
    }

    setYoutubeSeekTime(videoContainer, x) {
        const container = videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");
        const video = this.youtubePlayer;
        const time = (parseInt(video.getDuration()) * x) / timeline.getBoundingClientRect().width;
        video.seekTo(parseInt(time));
        if (video === YT.PlayerState.PLAYING) {
            video.playVideo();
            this.emitEvent("video_play");
        }
    }

    // LOCAL VIDEO
    setupSeek() {
        const container = this.videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");
        timeline.addEventListener("mousemove", (event) => {
            const { x, y } = this.getMouseCoordinate(event, timeline);
            this.setSeekPosition(x);
        });
        timeline.addEventListener("mouseleave", (event) => {
            this.setSeekPosition(0);
        });
        timeline.addEventListener("click", (event) => {
            const { x, y } = this.getMouseCoordinate(event, timeline);
            this.setSeekTime(this.videoContainer, x);
        });
    }

    setSeekTime(videoContainer, x) {
        const container = videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");
        const video = videoContainer.querySelector("video");
        const time = (parseInt(video.duration) * x) / timeline.getBoundingClientRect().width;
        video.currentTime = time;
        if (!video.paused) {
            this.setPlay(video);
            this.emitEvent("video_play");
        }
    }

    setPlay(video) {
        if (video.src) {
            video.play().catch((error) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("ERROR", error);
                document.querySelector("#genericStatusModal .medium-title").textContent = "VIDEO UPLOAD";
                document.querySelector("#genericStatusModal .message").textContent = error.message;
                jQuery("#genericStatusModal").modal("show");
                setTimeout(() => {
                    document.querySelector("#genericStatusModal .medium-title").textContent = "";
                    document.querySelector("#genericStatusModal .message").textContent = "";
                    jQuery("#genericStatusModal").modal("hide");
                }, 4000);
                this.resetVideo();
            });
            if (!video.paused) {
                this.videoContainer.querySelector("#localVideo").classList.add("playing");
                return this.startIntervalManager(this);
            }
            this.videoContainer.querySelector("#localVideo").classList.remove("playing");
        }
    }

    setPause(video) {
        this.videoContainer.querySelector("#localVideo").classList.remove("playing");
        clearInterval(this.playingInterval);
        video.pause();
    }

    startIntervalManager(_this) {
        _this.updateCurrentTime(_this.videoContainer);
        _this.playingInterval = setInterval(() => {
            _this.updateCurrentTime(_this.videoContainer);
        }, 1000);
    }

    updateCurrentTime(videoContainer) {
        const video = videoContainer.querySelector("video");
        videoContainer.querySelector(".current-timeline").textContent = this.formatTime(video.currentTime);
        const timeline = videoContainer.querySelector(".timeline");
        const x = (timeline.getBoundingClientRect().width * video.currentTime) / parseInt(video.duration);
        timeline.querySelector(".bar2").style.width = `${x}px`;
        videoContainer.querySelector(".seek-timeline").textContent = this.formatTime(video.duration);
    }

    setSeekPosition(x) {
        const container = this.videoContainer.querySelector(".timeline-container");
        const timeline = container.querySelector(".timeline");

        const video = this.videoContainer.querySelector("video");
        const positionTime = (parseInt(video.duration) * x) / timeline.getBoundingClientRect().width;

        const seekTime = this.formatTime(positionTime);
        container.querySelector(".seek-timeline").textContent = seekTime;

        timeline.querySelector(".bar3").style.width = `${x}px`;
    }

    setupUploadedVideo(file) {
        // var reader = new FileReader();
        const _this = this;
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(file);
        if (file.type.indexOf("video/") === -1) {
            const modal = "#videoErrorModal";
            document.querySelector(`${modal} .message`).textContent = "Video format not supported. Please load another video.";
            jQuery(modal).modal("show");
            return;
        }
        // if (file.size > this.maxVideoMB * 1000000) {
        //     const modal = "#videoErrorModal";
        //     document.querySelector(`${modal} .message`).textContent = `Video size over ${this.maxVideoMB}MB. Please load another video.`;
        //     jQuery(modal).modal("show");
        //     return;
        // }
        // reader.onload = (event) => {
        //     const src = event.target.result;
        //     console.log(src);
        //     _this.loadUploadedVideo(src, file.name);
        //     // _this.indexedDB.add(src, file.name);
        // };
        // reader.readAsDataURL(file);

        const src = window.URL.createObjectURL(file);
        _this.loadUploadedVideo(src, file.name);
    }

    loadUploadedVideo(src, name) {
        const video = this.videoContainer.querySelector("video#uploadedVideo");
        this.videoContainer.querySelector(".sync-tool-content").classList.add("hide");
        this.videoContainer.querySelector(".video-container").style.display = "";
        this.videoContainer.querySelector("#localVideo").style.display = "block";

        // document.querySelector(".fm-main-content").style.cssText += ";margin-top:650px"; /* 221229 - Sticky Header */

        // fetch(src)
        //     .then((res) => res.blob()) // Gets the response and returns it as a blob
        //     .then((blob) => {
        //         // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(blob);
        //         video.src = URL.createObjectURL(blob);

        //         video.muted = "muted";

        //         this.videoContainer.querySelector(".actions .video-name").textContent = name;

        //         this.setPlay(video);
        //         this.emitEvent("video_play");
        //     });

        video.src = src;
        video.load();

        video.muted = "muted";

        this.videoContainer.querySelector(".actions .video-name").textContent = name;

        // this.setPlay(video);
        // this.emitEvent("video_play");
    }

    qsToJson(queryString) {
        let res = {};
        let params = queryString.split("&");
        let keyValuePair, key, value;
        for (let i in params) {
            keyValuePair = params[i].split("=");
            key = keyValuePair[0];
            value = keyValuePair[1];
            res[key] = decodeURIComponent(value);
        }
        return res;
    }

    setupYoutubeVideo(url) {
        const _this = this;
        window.localStorage.setItem("youtube_video_url", url);
        fetch(`${Globals.WS_URL}?mode=YOUTUBE&url=${url}`)
            .then(this.handleResponse)
            .then((result) => {
                if (result.video && result.video.url) {
                    _this.setupSeek();
                    _this.loadUploadedVideo(result.video.url, result.video.title);
                    return;
                }

                throw { message: "NOT FOUND" };

                // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log({ message: "try setupIframe" });
                // _this.setupIframe(url);
            })
            .catch((error) => {
                document.querySelector("#genericStatusModal .medium-title").textContent = "VIDEO UPLOAD";
                document.querySelector("#genericStatusModal .message").textContent = error.message;
                jQuery("#genericStatusModal").modal("show");
                setTimeout(() => {
                    document.querySelector("#genericStatusModal .medium-title").textContent = "";
                    document.querySelector("#genericStatusModal .message").textContent = "";
                    jQuery("#genericStatusModal").modal("hide");
                }, 2000);
                this.resetVideo();

                // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log({ message: "try setupIframe" });
                // _this.setupIframe(url);
            });
    }

    showVideoFullscreen() {
        const video = this.videoContainer.querySelector("video");
        if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
        } else if (video.webkitRequestFullScreen) {
            video.webkitRequestFullScreen();
        }
    }
}